import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {isInclusivelyBeforeDay} from 'react-dates';

import {
  Wrapper,
  Title,
  Content,
  ButtonWrapper,
  LinkButton,
  Head,
} from '../../styles/pages/pages';
import {ExtraWrapper} from '../../styles/components/wrapper';
import {
  Selector,
  Option,
  AccountText,
  FilterWrapper,
  Block,
  Label,
} from './ReportPage.style';
import {getApiConfig} from '../../config/configProvider';
import {
  ANALYTICS_EVENTS,
  CUSTOMER_TYPES,
  JJ_DOMAIN,
  REPORT_TYPES,
  STANDARD_REPORT_FORMAT,
  TRANSACTION_TYPES,
} from '../../constants/constants';
import moment from 'moment';
import UnauthInfoPanel from '../../components/UnauthInfoPanel/UnauthInfoPanel';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import PowerBIReport from '../../components/PowerBiReport/PowerBiReport';
import {getReportToken} from '../../actions/reportToken.action';
import {setLoginRedirect} from '../../actions/loginRedirect.action';
import {REPORTS_PATH} from '../../constants/routePaths';

class ReportPage extends PureComponent {
  constructor(props) {
    super(props);
    this.today = moment();
    this.lastMonth = moment().subtract(1, 'months');
    this.sinceDate = moment(new Date('1985-01-01'));
    const cAccount = props.auth && props.auth.c_account;
    this.state = {
      reportType: REPORT_TYPES[0],
      startDate: this.lastMonth,
      endDate: this.today,
      customerList: cAccount,
      isAllTransaction: true,
    };
    this.config = getApiConfig();
  }

  componentDidMount() {
    this.props.getReportTokenFunc();
    if (window && window.location && window.location.hostname) {
      const hostname =
        window.location.hostname === JJ_DOMAIN.PROD
          ? JJ_DOMAIN.PROD
          : JJ_DOMAIN.DEV;
      this.setState({hostname});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {auth, getReportTokenFunc} = this.props;
    const {reportType} = this.state;
    if (!prevProps.auth && auth) {
      if (!this.state.customerList) {
        this.setState({customerList: auth.c_account});
      }
    }
    if (reportType !== prevState.reportType) {
      getReportTokenFunc();
    }
  }

  toggleTransactionType = () => {
    const isAllTransaction = !this.state.isAllTransaction;
    this.setState({isAllTransaction});
    GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.TRANSACTION_TYPE_CHANGE, {
      isAllTransaction,
    });
  };

  onViewAccountChange = option =>
    this.setState({customerList: option.target.value});

  onReportTypeChange = option => {
    this.setState({reportType: option.target.value});
    GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.REPORT_TYPE_CHANGE, {
      type: option.target.value,
    });
  };

  onDatesChange = ({startDate, endDate}) => this.setState({startDate, endDate});

  isOutsideRange = date => !isInclusivelyBeforeDay(date, this.today);

  isDayBlocked = date =>
    !isInclusivelyBeforeDay(date, this.today) ||
    isInclusivelyBeforeDay(date, this.sinceDate);

  render() {
    const {
      reportType,
      startDate,
      endDate,
      hostname,
      isAllTransaction,
      customerList,
    } = this.state;
    const {
      accounts,
      auth,
      relogin,
      loading,
      reportToken,
      setLoginRedirectFunc,
    } = this.props;
    if (!auth) {
      const handleLogin = () => {
        setLoginRedirectFunc(REPORTS_PATH);
        relogin();
      };
      return (
        <UnauthInfoPanel
          callback={handleLogin}
          loading={loading && loading.auth}
        />
      );
    }
    const customerNo =
      customerList === CUSTOMER_TYPES.ALL
        ? !!auth && auth.c_account
        : customerList;
    const src1 =
      auth &&
      customerList &&
      startDate &&
      endDate &&
      hostname &&
      `${
        this.config.reportApi
      }/MvcReportViewer.aspx?_r=/Reports/Web Customer Reports/${reportType}&datefrom=${startDate.format(
        STANDARD_REPORT_FORMAT
      )}&dateto=&CustomerList=${customerList}&CustomerNo=${customerNo}&TransactionType=${
        isAllTransaction ? TRANSACTION_TYPES.ALL : TRANSACTION_TYPES.OUTSTANDING
      }&token=${auth.access_token}&host=https://${hostname}`;
    const reportId = '3cddc292-ba37-401c-bad9-6309f8f4b172';
    // const src =
    //   customerList &&
    //   startDate &&
    //   endDate &&
    //   `https://app.powerbi.com/rdlEmbed?
    //   reportId=${reportId}&autoAuth=true&
    //   ctid=c46924d0-d32d-4006-829b-d1d39bd0f672&
    //   experience=power-bi&
    //   rp%3Adatefrom=${startDate.format(STANDARD_REPORT_FORMAT)}&
    //   rp%3Adateto=${endDate.format(
    //     STANDARD_REPORT_FORMAT
    //   )}&rp%3ACustomerNo=${customerNo}&rp%3ACustomerList=All&rp%3ATransactionType=All&token="350f3a2a-45ae-49d0-8bee-499b3bef03ab.c46924d0-d32d-4006-829b-d1d39bd0f672-login.windows.net-accesstoken-871c010f-5e61-4fb1-83ac-98610a7e9110-c46924d0-d32d-4006-829b-d1d39bd0f672-https://analysis.windows.net/powerbi/api/user_impersonation https://analysis.windows.net/powerbi/api/.default--"`;
    const renderAccounts =
      accounts &&
      accounts.map((account, key) => (
        <Option key={account.id + key} value={account.id || account.number}>
          {account.id} {account.name}
        </Option>
      ));
    const renderAllOption = accounts && accounts.length > 1 && (
      <Option value={CUSTOMER_TYPES.ALL}>All Accounts</Option>
    );
    const renderSelector = accounts && (
      <Selector value={customerList} onChange={this.onViewAccountChange}>
        {renderAllOption}
        {renderAccounts}
      </Selector>
    );
    const renderReportTypes = REPORT_TYPES.map(type => (
      <Option key={type} value={type}>
        {type}
      </Option>
    ));
    return (
      <Wrapper>
        <Head>
          <Title>My Reports</Title>
          <ButtonWrapper>
            <AccountText>Showing reports for</AccountText>
            {renderSelector}
          </ButtonWrapper>
        </Head>
        <Content>
          <FilterWrapper>
            {/* <Block>
              <Label>Select date range</Label>
              <RenderDateRangePicker
                isOutsideRange={this.isOutsideRange}
                isDayBlocked={this.isDayBlocked}
                startDateId={'fromDate'}
                endDateId={'toDate'}
                startDate={startDate}
                endDate={endDate}
                onDatesChange={this.onDatesChange}
              />
            </Block> */}
            <Block>
              <Label>Select report type</Label>
              <Selector
                value={reportType}
                onChange={this.onReportTypeChange}
                $maxWidth={true}
                id="reportyType"
              >
                {renderReportTypes}
              </Selector>
            </Block>
            {/* <CheckboxBlock>
              <CheckboxLabel
                onClick={this.toggleTransactionType}
                $alignRight={true}
              >
                <CheckMark $isChecked={isAllTransaction} />
                All transactions
              </CheckboxLabel>
              <CheckboxLabel onClick={this.toggleTransactionType}>
                <CheckMark $isChecked={!isAllTransaction} />
                Outstanding only
              </CheckboxLabel>
            </CheckboxBlock> */}
          </FilterWrapper>
          {reportToken && reportType && (
            <PowerBIReport
              embedToken={reportToken}
              reportType={reportType}
              customerNo={customerNo}
            />
          )}
        </Content>
        <ExtraWrapper>
          <LinkButton to="/">Continue shopping</LinkButton>
        </ExtraWrapper>
      </Wrapper>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  getReportTokenFunc: bindActionCreators(getReportToken, dispatch),
  setLoginRedirectFunc: bindActionCreators(setLoginRedirect, dispatch),
});

const mapStateToProps = state => ({
  auth: state.auth,
  accounts: state.accounts,
  loading: state.loading,
  reportToken: state.reportToken,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
